// Models
import { getCitiesByProvince, getProvinces } from "../../apis/entities";
import { JobAlert } from "../../apis/models/job-alert";
import { createOfferAlert, getOfferAlerts } from "../../apis/offer";
import { showModal, EuiModalSize } from "../../components/modal";
import { addToast } from "../../components/toasts";
import { getSession } from "../../helpers";
import { JobAlertFrequency, OfferAlert } from "../../models/offert-alert";
import { GENERAL_ERROR } from "../../resources";
import {
  ALERTS_NUMBER,
  ALERT_CREATED_ONE,
  ALERT_CREATED_MORE,
  CREATE_ALERT_TEXT,
  MAX_ALERTS_TEXT,
  ALERT_ALREADY_CREATED,
  ALERT_MAX_ALERTS,
} from "./settings";

// Constants
const CREATE_ALERT_SUB_MODAL_WRAPPER = () => $(".psf-create-alert-mobile-submodal-wrapper");
const CREATE_ALERT_SUB_MODAL_CLOSE_BTN = () => $(".psf-create-alert-mobile-submodal__btnClose");
const CREATE_ALERT_SUB_MODAL = () => $("#createAlertSubModal");
const CREATE_ALERT_PANEL_MOBILE = () => $("[psf-create-alert-modal-mobile]");
const CREATE_ALERT_BUTTON = () => $("[create-alert-button]");

const CREATE_ALERT_DESKTOP_BUTTON = () => $("[psf-create-alert-modal]");
const CREATE_ALERT_DESKTOP_NUMBER = () => $("[create-alert-desktop-number]");
const CREATE_ALERT_DESKTOP_TEXT = () => $("[create-alert-desktop-text]");
const CREATE_ALERT_DESKTOP_LINK = () => $("[create-alert-desktop-link]");

const CREATE_ALERT_MOBILE_BTN_ICON_NUMBER = () => $("[create-alert-mobile-btn-number]");
const CREATE_ALERT_MOBILE_BTN_ICON = () => $("[create-alert-mobile-btn-icon]");

const CREATE_ALERT_MOBILE_NUMBER = () => $("[create-alert-mobile-number]");
const CREATE_ALERT_MOBILE_TEXT = () => $("[create-alert-mobile-text]");
const CREATE_ALERT_MOBILE_ICON_NUMBER = () => $("[create-alert-mobile-icon-number]");
const CREATE_ALERT_MOBILE_ICON = () => $("[create-alert-mobile-icon]");
const CREATE_ALERT_MOBILE_LINK = () => $("[create-alert-mobile-link]");

const FRECUENCIES_INPUT_CHECKED = () =>
  $("input[type='radio'][name='frecuencies']:checked");
const ALERT_FORM_CITIES = () =>
  document.querySelectorAll("[psf-create-alert-city]");
const ALERT_FORM_PROVINCE = () => document.querySelector("[data-province]");
const ALERT_FORM_FUNCTION = () =>
  document.querySelector("[psf-create-alert-search]");
const CLOSE_ALERT_MODAL_BUTTON = () => $(".psfModal__btnClose");

// Request
let offertAlert: OfferAlert;
let selectedProvince: { id: number; description: string };
let selectedCities: Array<{ id: number; description: string }>;
let currentAlerts: number = 0;
let maxOfferAlerts: number = 0;

$(() => {
  currentAlerts = parseInt(ALERTS_NUMBER);
  maxOfferAlerts = parseInt(ALERT_MAX_ALERTS);
  _initCreateAlertSubModal();
  _initLoginModal();
  _initCreateAlertModal();
});

function _initLoginModal(): void {
  $(document).on(
    "click",
    "[psf-create-alert-login], [psf-create-alert-login-mobile]",
    (e) => {
      showModal("#createAlertLoginModal", {
        isFullScreen: true,
        size: EuiModalSize.S,
      });
    }
  );
}

function _initCreateAlertSubModal(): void {
  $(document).on(
    "click",
    "[psf-create-alert-submodal-mobile]",
    () => showAlertSubModal()
  );
}

function _initCreateAlertModal(): void {
  $(document).on(
    "click",
    "[psf-create-alert-modal], [psf-create-alert-modal-mobile]",
    (e) => {
      showModal("#createAlertModal", {
        isFullScreen: true,
        size: EuiModalSize.S,
      });
      closeAlertSubModal();
    }
  );

  offertAlert = {
    function: 1,
    province: 1,
    frequency: JobAlertFrequency.DIARY,
  };

  $(document).on("click", "[create-alert-button]", async () => {
    CREATE_ALERT_BUTTON().prop("disabled", true);

    const session = getSession();
    const provinces = await getProvinces(session.countryId);
    selectedCities = [];

    const province = ALERT_FORM_PROVINCE()?.getAttribute("data-province")!;
    selectedProvince = _getSelectedProvince(province, provinces);

    const cities = await getCitiesByProvince(selectedProvince.id);
    ALERT_FORM_CITIES()?.forEach((city) =>
      selectedCities.push(
        _getSelectedCityId(city.getAttribute("data-city")!, cities)
      )
    );

    const autocompletedSearchText =
      ALERT_FORM_FUNCTION()?.getAttribute("data-function")!;
    const frequency = +(FRECUENCIES_INPUT_CHECKED().val() ?? 1);

    try {
      const offerAlerts: Array<JobAlert> = await getOfferAlerts();

      if (offerAlerts.length + 1 <= maxOfferAlerts) {
        await createOfferAlert(
          session.countryId,
          selectedProvince,
          selectedCities,
          autocompletedSearchText,
          frequency
        );
        addToast(CREATE_ALERT_TEXT, "success", 2000);
        window.dataLayer?.push({
          event: "createAlertJobs",
        });

        _updateAlertBlockComponents();
        _closeCreateAlertModal();
      } else {
        addToast(MAX_ALERTS_TEXT, "error", 2000);
        _closeCreateAlertModal();
      }

      // Reset form submit button
      CREATE_ALERT_BUTTON().prop("disabled", false);
    } catch (error: any) {
      CREATE_ALERT_BUTTON().prop("disabled", false);
      addToast(GENERAL_ERROR, "error", 2000);
    }
  });
}

function _getSelectedProvince(
  provinceToFind: string,
  provinces: Array<{ id: number; description: string }>
): { id: number; description: string } {
  const province = provinces.find(
    (province) =>
      province.description.replaceAll("-", " ").toUpperCase() ===
      provinceToFind.replaceAll("-", " ").toUpperCase()
  )!;
  if (!province) console.error("PROVINCE NOT FOUND");

  return {
    id: province?.id,
    description: province?.description,
  };
}

function _getSelectedCityId(
  city: string,
  cities: Array<{ id: number; description: string }>
): { id: number; description: string } {
  const cityFound = cities.find(
    (cityItem) =>
      cityItem.description.replaceAll("-", " ").toUpperCase() ===
      city.replaceAll("-", " ").toUpperCase()
  )!;
  if (!cityFound) console.error("CITY NOT FOUND");

  return {
    id: cityFound?.id,
    description: cityFound?.description,
  };
}

function showAlertSubModal() {
  CREATE_ALERT_SUB_MODAL_WRAPPER().css('top', 0);
  CREATE_ALERT_SUB_MODAL().css('bottom', 0);
  CREATE_ALERT_SUB_MODAL_WRAPPER().on("click", () => closeAlertSubModal());
  CREATE_ALERT_SUB_MODAL_CLOSE_BTN().on("click", () => closeAlertSubModal());
  $("body").css("overflow", "hidden");
}

export function closeAlertSubModal() {
  CREATE_ALERT_SUB_MODAL_WRAPPER().css('top', "-100%");
  CREATE_ALERT_SUB_MODAL().css('bottom', "-245px");
  CREATE_ALERT_SUB_MODAL_WRAPPER().off("click");
  CREATE_ALERT_SUB_MODAL_CLOSE_BTN().off("click");
  $("body").css("overflow", "initial");
}

function _closeCreateAlertModal() {
  CLOSE_ALERT_MODAL_BUTTON().trigger("click");
}

function _updateAlertBlockComponents() {
  currentAlerts++;
  const createdNumberText: string = currentAlerts == 1 ? `${currentAlerts} ${ALERT_CREATED_ONE}` : `${currentAlerts} ${ALERT_CREATED_MORE}`;
  const createdText: string = ALERT_ALREADY_CREATED;
  
  // Desktop block
  CREATE_ALERT_DESKTOP_NUMBER().text(createdNumberText);
  CREATE_ALERT_DESKTOP_BUTTON().prop("disabled", true);
  CREATE_ALERT_DESKTOP_TEXT().text(createdText);
  CREATE_ALERT_DESKTOP_LINK().removeClass('eui-d-none');

  // Mobile button block
  CREATE_ALERT_MOBILE_BTN_ICON_NUMBER().remove();
  CREATE_ALERT_MOBILE_BTN_ICON().attr("src", "/icons/notification-success.svg");

  // Mobile block
  CREATE_ALERT_MOBILE_NUMBER().text(createdNumberText);
  CREATE_ALERT_MOBILE_TEXT().text(createdText);
  CREATE_ALERT_PANEL_MOBILE().prop("disabled", true);
  CREATE_ALERT_MOBILE_ICON_NUMBER().remove();
  CREATE_ALERT_MOBILE_ICON().attr("src", "/icons/notification-success.svg");
  CREATE_ALERT_MOBILE_LINK().removeClass('eui-d-none');
}
